import styled from 'styled-components';

const BasicDivBlock = styled.div`
  padding: 20px;
`;

export default BasicDivBlock;
